import { createAction, createAsyncAction } from 'typesafe-actions';

import type { Whitelist } from '@portal/api-models';

import type { IsomorphicRequestPayload } from '../types';

import { WhitelistActionType } from './actionTypes';
import type {
  CreateMultipleWhitelistRequestPayload,
  CreateWhitelistRequestPayload,
  DeleteWhitelistRequestPayload,
  DeleteWhitelistResponse,
} from './types';

export const getAllWhitelistAction = createAsyncAction(
  WhitelistActionType.GET_ALL_WHITELIST_REQUEST,
  WhitelistActionType.GET_ALL_WHITELIST_SUCCESS,
  WhitelistActionType.GET_ALL_WHITELIST_FAILURE
)<IsomorphicRequestPayload, Whitelist[], Error>();

export const createWhitelistAction = createAsyncAction(
  WhitelistActionType.CREATE_WHITELIST_REQUEST,
  WhitelistActionType.CREATE_WHITELIST_SUCCESS,
  WhitelistActionType.CREATE_WHITELIST_FAILURE
)<CreateWhitelistRequestPayload, Whitelist, Error>();

export const createMultipleWhitelistAction = createAsyncAction(
  WhitelistActionType.CREATE_MULTIPLE_WHITELIST_REQUEST,
  WhitelistActionType.CREATE_MULTIPLE_WHITELIST_SUCCESS,
  WhitelistActionType.CREATE_MULTIPLE_WHITELIST_FAILURE
)<CreateMultipleWhitelistRequestPayload, Whitelist[], Error>();

export const deleteWhitelistAction = createAsyncAction(
  WhitelistActionType.DELETE_WHITELIST_REQUEST,
  WhitelistActionType.DELETE_WHITELIST_SUCCESS,
  WhitelistActionType.DELETE_WHITELIST_FAILURE
)<DeleteWhitelistRequestPayload, DeleteWhitelistResponse, Error>();

export const toggleCreateWhitelist = createAction(
  WhitelistActionType.TOGGLE_CREATE
)<undefined>();
